import { CardContent, IconButton } from '@mui/material';
import { useContext } from 'react';
import CartItemImageArteFinal from '../Cart/CartItem/CartItemImageArteFinal';
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import FavouriteSelected from './FavouriteSelected';
import { UserContext } from '../../context/UserProvider';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import MaterialTooltip from '../../ui/tooltip/MaterialTooltip';

export const OneRowArte = ({ row, handleRowClick }) => {
  const { userRole } = useContext(UserContext);
  const [selectedIdsFavorite, setSelectedIdsFavorite] = useState([
    {
      idArte: row._id,
      centers: row.favourite.length > 0 ? row.favourite : [],
    },
  ]);

  const truncateName = (name, maxLength) => {
    if (name?.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  };

  // Definir el nombre truncado y si necesita un tooltip
  const truncatedName = truncateName(row.nameArteFinal, 85);
  const needsTooltip = row.nameArteFinal.length > 85;

  return (
    <div>
      <div
        className={
          'card-arte-final' +
          ((row?.allFormatsWithErrors && !row.isDescargable && !row.isInformational) ||
          row?.centerType?.length === 0 ||
          row?.allCategoriesDisabled === true ||
          (row.isDescargable &&
            !row.pdfLanguages?.castellano &&
            !row.pdfLanguages?.['País Vasco'] &&
            !row.pdfLanguages?.Cataluña &&
            !row.pdfLanguages?.Galicia)
            ? ' incomplete'
            : '') +
          (row.active ? '' : ' inactive')
        }
      >
        {userRole === 'MasterAdmin' && (
          <FavouriteSelected
            row={row}
            selectedIdsFavorite={selectedIdsFavorite}
            setSelectedIdsFavorite={setSelectedIdsFavorite}
          />
        )}
        <CartItemImageArteFinal
          onClick={() => handleRowClick(row)}
          styleContainer={{
            height: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          styleImg={{
            cursor: 'pointer',
            objectFit: 'contain',
            height: '90%',
            width: '90%',
          }}
          img={row.imglink}
        />
        <CardContent
          sx={{ padding: '0.5rem !important', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div style={{ textAlign: 'center', height: '80px' }}>
            <p
              className={`tooltip-artefinal-name-${row._id}`}
              style={{ marginBottom: '5px', fontWeight: 'bold' }}
              data-tip={needsTooltip ? row.nameArteFinal : ''}
            >
              {truncatedName.toUpperCase()}
            </p>
            <p style={{ fontStyle: 'italic' }}> {row.codeArteFinal} </p>
          </div>
        </CardContent>
        <div
          style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse', minHeight: '55px' }}
        >
          {row.isInformational && (
            <MaterialTooltip title="Información: tamaño y material orientativo para pedir adaptación al tamaño contacta v.rubio@alcampo.es">
              <IconButton>
                <MenuBookIcon
                  style={{
                    margin: '0.5rem',
                  }}
                />
              </IconButton>
            </MaterialTooltip>
          )}
        </div>
      </div>

      {needsTooltip && (
        <Tooltip style={{ zIndex: 1000 }} anchorSelect={`.tooltip-artefinal-name-${row._id}`}>
          {row.nameArteFinal.toUpperCase()}
        </Tooltip>
      )}
    </div>
  );
};
